import { Button, Grid, LinearProgress } from "@material-ui/core";
import Axios from "axios";
import React, { Component } from "react";
import { Badge, Form, Modal, Row, Table, Alert } from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import AppConfig from "../../../../../config/AppConfig";

class KebijakanPerguruanTinggi extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChangeAlasan = this.handleChangeAlasan.bind(this);
    this.handleCloseTidakAda = this.handleCloseTidakAda.bind(this);
    this.handleCloseAda = this.handleCloseAda.bind(this);
    this.handleShowAdd = this.handleShowAdd.bind(this);
    this.handleCloseAdd = this.handleCloseAdd.bind(this);
    this.handleSHowDelete = this.handleSHowDelete.bind(this);
    this.handleCloseDelete = this.handleCloseDelete.bind(this);

    this.handleCloseHistorical = this.handleCloseHistorical.bind(this);
    this.handleCloseEdit = this.handleCloseEdit.bind(this);
    ///handleShowStatusPengelolaanbase
    this.handleShowPendidikanbase = this.handleShowPendidikanbase.bind(this);
    this.handleShowPendidikan = this.handleShowPendidikan.bind(this);
    this.handleShowPenelitianbase = this.handleShowPenelitianbase.bind(this);
    this.handleShowPenelitian = this.handleShowPenelitian.bind(this);
    this.handleShowPengabdianbase = this.handleShowPengabdianbase.bind(this);
    this.handleShowPengabdian = this.handleShowPengabdian.bind(this);
    this.handleShowPengelolaanbase = this.handleShowPengelolaanbase.bind(this);
    this.handleShowPengelolaan = this.handleShowPengelolaan.bind(this);
    this.handleShowKemahasiswaanbase = this.handleShowKemahasiswaanbase.bind(
      this
    );
    this.handleShowKemahasiswaan = this.handleShowKemahasiswaan.bind(this);
    this.handleShowSdmbase = this.handleShowSdmbase.bind(this);
    this.handleShowSdm = this.handleShowSdm.bind(this);
    this.handleShowSarprasbase = this.handleShowSarprasbase.bind(this);
    this.handleShowSarpras = this.handleShowSarpras.bind(this);
    this.handleShowKerjasamabase = this.handleShowKerjasamabase.bind(this);
    this.handleShowKerjasama = this.handleShowKerjasama.bind(this);
    this.handleShowKeuanganbase = this.handleShowKeuanganbase.bind(this);
    this.handleShowKeuangan = this.handleShowKeuangan.bind(this);
    this.handleShowKesejahteraanbase = this.handleShowKesejahteraanbase.bind(
      this
    );
    this.handleShowKesejahteraan = this.handleShowKesejahteraan.bind(this);
    this.showDialogDelete = this.showDialogDelete.bind(this);
    // STATE
    this.state = {
      delete_id: "",
      showDeleteDialog: false,
      showAda: false,
      showTidakAda: false,
      showDelete: false,
      showEdit: false,
      isRadioSelected: true,
      loadingBar: true,
      alasan: "",
      showAdd: false,
      user_data: [],
      get_pengaturan_institusi: [],
      get_pt_institusi: [],
      get_pt_lain: [],
      //Data
      aspek1pendidikan: "",
      aspek2penelitian: "",
      aspek3pengabdian: "",
      aspek4pengelolaan: "",
      aspek5kemahasiswaan: "",
      aspek6sdm: "",
      aspek7sarpras: "",
      aspek8kerjasama: "",
      aspek9keuangan: "",
      aspek10kesejahteraan: "",
      ///POST PENGATURAN
      id_ajuan_pengaturan: "",
      id_jenis_aturan: "",
      keterangan: "",
      tautan: "",
      tanggal_penetapan: "",
      status: "",
      created_at: "",
      id_updater: "",
      id_sp: "",
      updated_at: "",
      loading: false,
      ///EDIT
      statusajuanEdit: "",
      statusEdit: "",
      id_jenis_aturanEdit: "",
      tautanEdit: "",
      deskripsiEdit: "",
      id_ajuan_pengaturanEdit: "",
      //HISTORICAL
      showHistorical: false,
      get_jenis: [],
      dataHistorical: [],
      display_datahistorical: false,
    };
  }

  // Begin Modal Delete =====================================================================
  showDialogDelete(id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Catatan akan terhapus, dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        Axios.get(AppConfig.urlDeletePengaturan + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Data telah dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
            this.setState({
              loading: false,
              showAda: false,
              tautan: [],
              tanggal_penetapan: [],
              status: [],
              id_jenis_evaluasi: [],
            });
            console.log(res);
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
            // alert("GAGAL")
            this.setState({
              loading: false,
            });
          });
      }
    });
  }
  // End Modal Delete =====================================================================

  handleChangeAlasan(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value === "belumada" ? 0 : value === "proses" ? 1 : "",
    });
    if (value === "lainnya") {
      this.setState({ isRadioSelected: false });
    } else {
      this.setState({ isRadioSelected: true });
    }
  }
  handleCloseAda() {
    this.setState({
      showAda: false,
      showDeleteDialog: false,
      id_jenis_aturan: "",
      tautan: "",
      tanggal_penetapan: "",
      status: "",
      keterangan: "",
      id_sp: "",
    });
  }
  handleCloseTidakAda() {
    this.setState({
      showTidakAda: false,
      keterangan: "",
      id_jenis_aturan: "",
      tautan: "",
      tanggal_penetapan: "",
      status: "",
      id_sp: "",
    });
  }
  handleSHowDelete() {
    this.setState({
      showDelete: true,
    });
  }
  handleCloseDelete() {
    this.setState({
      showDelete: false,
    });
  }
  handleShowAdd() {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    this.setState({
      showAdd: true,
      id_jenis_aturan: 17,
      id_sp: userdata.i_idunit,
      status: 1,
    });
  }
  handleCloseAdd() {
    this.setState({
      showAdd: false,
      showTidakAda: false,
      keterangan: "",
      id_jenis_aturan: "",
      tautan: "",
      tanggal_penetapan: "",
      status: "",
      id_sp: "",
    });
  }
  handleAddPengaturan = (e) => {
    this.setState({ loading: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    e.preventDefault();
    var formData = new FormData();
    formData.append(
      "data[id_ajuan_pengaturan]",
      this.state.id_ajuan_pengaturan
    );
    formData.append("data[id_jenis_aturan]", this.state.id_jenis_aturan);
    formData.append("data[tautan]", this.state.tautan);
    formData.append("data[deskripsi]", this.state.deskripsi);
    formData.append("data[keterangan]", this.state.keterangan);
    formData.append("data[status]", this.state.status);
    formData.append("data[id_sp]", this.state.id_sp);
    Axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    Axios.post(AppConfig.urlAPiPostDataPT + session, formData)
      .then((res) => {
        swal({
          title: "Berhasil!",
          text: "pengaturan berhasil!",
          icon: "success",
          button: "OK!",
        });
        // alert("BERHASIL")
        // console.log(res)
        this.componentDidMount();
        this.setState({
          showAda: false,
          showTidakAda: false,
          id_jenis_aturan: "",
          tautan: "",
          keterangan: "",
          status: "",
          id_sp: "",
          loading: false,
        });
      })
      .catch((err) => {
        // alert("GAGAL")
        swal({
          title: "Gagal!",
          text: "proses gagal!",
          icon: "error",
          button: "OK!",
        });
        this.setState({
          showAda: false,
          showTidakAda: false,
          id_jenis_aturan: "",
          tautan: "",
          keterangan: "",
          status: "",
          id_sp: "",
          loading: false,
        });
      });
  };
  handleSavePengaturanEdit = (e) => {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    e.preventDefault();
    swal({
      title: "Apakah anda yakin?",
      text: "Data pengaturan sebelumnya akan dijadikan data historical!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        let session_tahun_siklus = localStorage.getItem("tahun_siklus")
        var formData = new FormData();
        // formData.append(
        //   "data[id_ajuan_pengaturan]",
        //   this.state.id_ajuan_pengaturanEdit
        // );
        formData.append("data[tahun_siklus]", session_tahun_siklus);
        formData.append("data[statusajuan]", this.state.statusajuanEdit);
        formData.append("data[tautan]", this.state.tautanEdit);
        formData.append("data[deskripsi]", this.state.deskripsiEdit);
        formData.append("data[status]", this.state.statusEdit);
        formData.append(
          "data[id_jenis_aturan]",
          this.state.id_jenis_aturanEdit
        );
        formData.append("data[id_sp]", sessiondata.i_idunit);
        Axios.defaults.headers.post["Content-Type"] =
          "application/x-www-form-urlencoded";
        Axios.post(AppConfig.urlAPiPostDataPT + session, formData)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengaturan berhasil diperbarui!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
            this.setState({
              showEdit: false,
              id_ajuan_pengaturanEdit: "",
              tautanEdit: "",
              deskripsiEdit: "",
              tanggal_penetapanEdit: "",
              loading: false,
            });
            console.log(res);
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "pengaturan gagal diperbarui!",
              icon: "error",
              button: "OK!",
            });
            // alert("GAGAL")
            this.setState({
              showEdit: false,
              id_ajuan_pengaturanEdit: "",
              tautanEdit: "",
              deskripsiEdit: "",
              tanggal_penetapanEdit: "",
              loading: false,
            });
          });
        // swal("Poof! Your imaginary file has been deleted!", {
        //   icon: "success",
        // });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };
  handleCloseEdit() {
    this.setState({
      showEdit: false,
      // UPDATE STATE
      statusajuanEdit: "",
      id_ajuan_pengaturanEdit: "",
      tautanEdit: "",
      deskripsiEdit: "",
      tanggal_penetapanEdit: "",
    });
  }
  handleCloseHistorical() {
    this.setState({
      showHistorical: false,
    });
  }
  handleShowHistorical = (event) => {
    this.setState({
      showHistorical: true,
      display_datahistorical: false,
      loading: false,
      get_jenis: event,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    Axios.get(
      AppConfig.urlGetHistoricalPengaturanSiklus + id_sp + "/" + event + "/" + tahun_siklus + session
    )
      .then((res) => {
        this.setState(
          {
            dataHistorical: res.data.result.data,
            display_datahistorical: true,
          },
          () => { }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleClickInterface = (id_jenis_aturan) => {
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    swal({
      title: "Konfirmasi",
      text: "Apakah Anda ingin menyalin pengaturan SPMI ini dari tahun sebelumnya untuk tahun " + tahun_siklus + "?",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }

        this.setState({ loading: true });
        let session_tahun_siklus = localStorage.getItem("tahun_siklus")
        Axios.get(AppConfig.urlDefault + "penetapan/savepengaturancp/" + id_jenis_aturan + "/" + session_tahun_siklus + session)
          .then((res) => {
            this.setState({ loading: false });
            if (res.data.status === "error") {
              swal("Gagal!", res.data.message, {
                icon: "error",
              });
              return
            } else {
              swal("Berhasil!", "Pengaturan telah ditetapkan untuk tahun " + session_tahun_siklus, {
                icon: "success",
              });
            }
            this.componentDidMount();
          })
          .catch((err) => {
            this.setState({ loading: false });
            swal("Gagal!", "Pengaturan gagal ditetapkan untuk tahun " + session_tahun_siklus, {
              icon: "error",
            });
          });
      }
    });
  };
  onInputChangePengaturan = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  //Standar di aspek pendidikan
  //POST
  handleShowPendidikanbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 7,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 7,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowPendidikan(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t7
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 7,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t7
          .id_ajuan_pengaturan,
        id_jenis_aturan: 7,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  handleEditButtonP7 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 7,
      tautanEdit: this.state.get_pengaturan_institusi.t7.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t7.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t7
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP8 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 8,
      tautanEdit: this.state.get_pengaturan_institusi.t8.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t8.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t8
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP9 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 9,
      tautanEdit: this.state.get_pengaturan_institusi.t9.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t9.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t9
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP10 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 10,
      tautanEdit: this.state.get_pengaturan_institusi.t10.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t10.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t10
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP11 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 11,
      tautanEdit: this.state.get_pengaturan_institusi.t11.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t11.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t11
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP12 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 12,
      tautanEdit: this.state.get_pengaturan_institusi.t12.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t12.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t12
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP13 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 13,
      tautanEdit: this.state.get_pengaturan_institusi.t13.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t13.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t13
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP14 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 14,
      tautanEdit: this.state.get_pengaturan_institusi.t14.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t14.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t14
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP15 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 15,
      tautanEdit: this.state.get_pengaturan_institusi.t15.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t15.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t15
        .id_ajuan_pengaturan,
    });
  };
  handleEditButtonP16 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 16,
      tautanEdit: this.state.get_pengaturan_institusi.t16.tautan,
      deskripsiEdit: this.state.get_pengaturan_institusi.t16.deskripsi,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan_institusi.t16
        .id_ajuan_pengaturan,
    });
  };
  //Standar di aspek penelitian
  //POST
  handleShowPenelitianbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 8,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 8,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowPenelitian(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t8
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 8,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t8
          .id_ajuan_pengaturan,
        id_jenis_aturan: 8,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek penelitian pengabdian pada masyarakat
  //POST
  handleShowPengabdianbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 9,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 9,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowPengabdian(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t9
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 9,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t9
          .id_ajuan_pengaturan,
        id_jenis_aturan: 9,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek pengelolaan organisasi
  //POST
  handleShowPengelolaanbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 10,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 10,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowPengelolaan(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t10
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 10,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t10
          .id_ajuan_pengaturan,
        id_jenis_aturan: 10,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek kemahasiswaan
  //POST
  handleShowKemahasiswaanbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 11,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 11,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowKemahasiswaan(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t11
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 11,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t11
          .id_ajuan_pengaturan,
        id_jenis_aturan: 11,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek sumber daya manusia
  //POST
  handleShowSdmbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 12,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 12,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowSdm(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t12
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 12,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t12
          .id_ajuan_pengaturan,
        id_jenis_aturan: 12,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek aspek sarana prasarana
  //POST
  handleShowSarprasbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 13,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 13,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowSarpras(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t13
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 13,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t13
          .id_ajuan_pengaturan,
        id_jenis_aturan: 13,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek aspek Kerjasama
  //POST
  handleShowKerjasamabase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 14,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 14,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowKerjasama(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t14
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 14,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t14
          .id_ajuan_pengaturan,
        id_jenis_aturan: 14,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek aspek keuangan
  //POST
  handleShowKeuanganbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    console.log(userdata.i_idunit);
    console.log(value);
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 15,
        status: 1,
        id_sp: userdata.i_idunit,
        // id_sp: "83B42285-EDB7-4396-B2A6-00DE83333E63",
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 15,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
        // id_sp: "83B42285-EDB7-4396-B2A6-00DE83333E63",
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowKeuangan(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    console.log(this.state.get_pengaturan_institusi.t15.id_ajuan_pengaturan);
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t15
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 15,
        status: 1,
        id_sp: userdata.i_idunit,
        // id_sp: "83B42285-EDB7-4396-B2A6-00DE83333E63",
      });
    } else {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t15
          .id_ajuan_pengaturan,
        showTidakAda: true,
        id_jenis_aturan: 15,
        status: 0,
        id_sp: userdata.i_idunit,
        // id_sp: "83B42285-EDB7-4396-B2A6-00DE83333E63",
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  //Standar di aspek aspek kesejahteraan
  //POST
  handleShowKesejahteraanbase(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 16,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 16,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  ///UPDATE
  handleShowKesejahteraan(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t16
          .id_ajuan_pengaturan,
        showAda: true,
        id_jenis_aturan: 16,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_ajuan_pengaturan: this.state.get_pengaturan_institusi.t16
          .id_ajuan_pengaturan,
        id_jenis_aturan: 16,
        status: 0,
        id_sp: userdata.i_idunit,
        tanggal_penetapan: null,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  handleSavePengaturanInstitusi = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        this.setState({ loading: true });
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        e.preventDefault();
        console.log(this.state);
        var formData = new FormData();
        formData.append(
          "data[id_ajuan_pengaturan]",
          this.state.id_ajuan_pengaturan
        );
        formData.append("data[id_jenis_aturan]", this.state.id_jenis_aturan);
        formData.append("data[tautan]", this.state.tautan);
        formData.append("data[deskripsi]", this.state.deskripsi);
        let session_tahun_siklus = localStorage.getItem("tahun_siklus")
        formData.append("data[tahun_siklus]", session_tahun_siklus);
        formData.append("data[keterangan]", this.state.keterangan);
        formData.append("data[status]", this.state.status);
        formData.append("data[id_sp]", this.state.id_sp);
        Axios.defaults.headers.post["Content-Type"] =
          "application/x-www-form-urlencoded";
        Axios.post(AppConfig.urlAPiPostDataPT + session, formData)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "pengaturan berhasil!",
              icon: "success",
              button: "OK!",
            });
            // alert("BERHASIL")
            // console.log(res)
            this.componentDidMount();
            this.setState({
              showAda: false,
              showTidakAda: false,
              id_jenis_aturan: "",
              tautan: "",
              keterangan: "",
              status: "",
              id_sp: "",
              loading: false,
            });
          })
          .catch((err) => {
            // alert("GAGAL")
            swal({
              title: "Gagal!",
              text: "proses gagal!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              showAda: false,
              showTidakAda: false,
              id_jenis_aturan: "",
              tautan: "",
              keterangan: "",
              status: "",
              id_sp: "",
              loading: false,
            });
          });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };
  deletePengaturanLain = () => {
    let { delete_id } = this.state;
    this.setState({
      loading: true,
    });
    // var formData = new FormData();
    // this.setState({loading: true})
    // formData.append('data[id_ajuan_pengaturan]', id);
    // Axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
    // Axios.post(AppConfig.urlAPiPostDataPT, formData)
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    Axios.post(AppConfig.urlAPiPostDataPT + "/" + delete_id + session)
      .then((res) => {
        // console.log("Berhasil===",res)
        swal({
          title: "Berhasil!",
          text: "pengaturan berhasil!",
          icon: "success",
          button: "OK!",
        });
        this.componentDidMount();
        // alert("berhasil!");
        this.setState({ loading: false });
      })
      .catch((err) => {
        // console.log(err);
        // alert("gagal")
        swal({
          title: "Gagal!",
          text: "pengaturan gagal!",
          icon: "error",
          button: "OK!",
        });
        this.setState({ loading: false });
      });
  };
  handleTahunSiklusChanged = () => {
    this.setState({ loadingBar: true });
    this.componentDidMount();
  };
  componentWillUnmount() {
    window.removeEventListener("tahunSiklusChanged", this.handleTahunSiklusChanged);
    window.removeEventListener("storage", this.handleTahunSiklusChanged);
  }
  componentDidMount() {
    if (!this.hasYearSelectListener) {
      window.addEventListener("tahunSiklusChanged", this.handleTahunSiklusChanged);
      window.addEventListener("storage", this.handleTahunSiklusChanged);
      this.hasYearSelectListener = true;
    }
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    console.log(sessiondata.i_idrole);
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let session_tahun_siklus = localStorage.getItem("tahun_siklus")
    Axios.get(AppConfig.urlGetPengaturan + id_sp + "/" + session_tahun_siklus + session)
      .then((res) => {
        this.setState(
          {
            get_pengaturan_institusi: res.data.result.pengaturan,
            get_pt_institusi: res.data.result.pengaturanpt,
            loadingBar: false,
          },
          () => {
            console.log(this.state.get_pengaturan_institusi);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }
  onInputChange = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  showDialogDelete(id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Catatan akan terhapus, dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        Axios
          .get(AppConfig.urlDeletePengaturan + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengaturan Evaluasi berhasil!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
            this.setState({
              loading: false,
              showAda: false,
              showEdit: false,
              id_jenis_aturan: "",
              id_sp: "",
              tautan: "",
              keterangan: "",
              tanggal_penetapan: "",
              status: "",
            });
            console.log(res);
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              loading: false,
            });
          });
      }
    });
  }

  render() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let {
      keterangan,
      tautan,
      deskripsi,
      deskripsiEdit,
      loading,
      dataHistorical,
      showHistorical,
    } = this.state;
    let display_historical = [];
    if (this.state.display_datahistorical === true) {
      dataHistorical.map((list, i) => {
        display_historical.push(
          <>
            <tr>
              <td style={{ textAlign: "center" }}>
                {list.status === 1 ? (
                  "Ada"
                ) : list.status === 0 ? (
                  "Tidak ada"
                ) : list.status === 2 ? (
                  "Dalam unit tersendiri"
                ) : list.status === 3 ? (
                  <>
                    <i>Embedded</i>dalam organisasi institusi
                  </>
                ) : list.status === 4 ? (
                  <>
                    <i>embedded</i>Kombinasi unit pengelola dan{" "}
                  </>
                ) : (
                  "-"
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tautan === "null" ? (
                  list.keterangan
                ) : (
                  <a target="_blank" className="menu-link" href={list.tautan}>
                    <Button
                      className="btn btn-icon btn-success btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon-attachment"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </a>
                )}
              </td>
              {/* <td style={{textAlign:'center'}}>
                  {
                    list.statusajuan === 3 ? 
                    <Badge pill variant="success"  style={{ marginRight:'3px', marginBottom:'3px'}}>
                                <Badge variant="light"> <span style={{color:'#37bf30'}}>✔</span></Badge>&nbsp;&nbsp;&nbsp;
                                Terverifikasi
                              </Badge>
                    : 
                    list.statusajuan === 1 ?
                      <Badge pill variant="secondary"  style={{ marginRight:'3px', marginBottom:'3px'}}>
                        <Badge variant="light"> <span style={{color:'#858585'}}>•</span></Badge>&nbsp;&nbsp;&nbsp;
                        Belum Terverifikasi
                      </Badge>
                      :
                      <Badge pill variant="secondary"  style={{ marginRight:'3px', marginBottom:'3px'}}>
                        -
                      </Badge>
                  }
                </td> */}
              <td style={{ textAlign: "center" }}>
                <Moment
                  format="DD/MM/YYYY"
                  date={list.created_at === "null" ? "-" : list.created_at}
                />
              </td>
            </tr>
          </>
        );
      });
    } else {
      display_historical = (
        <>
          <tr>
            <td colSpan="6">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }
    let {
      //1. P7
      p7status,
      p7tautan,
      p7keterangan,
      p7edit,
      p7delete,
      p7document,
      p7verifikasi,
      p7buttonHistorical,
      p7buttonInterface,
      //2. P8
      p8status,
      p8tautan,
      p8keterangan,
      p8edit,
      p8delete,
      p8document,
      p8verifikasi,
      p8buttonHistorical,
      p8buttonInterface,
      //3. P9
      p9status,
      p9tautan,
      p9keterangan,
      p9edit,
      p9delete,
      p9document,
      p9verifikasi,
      p9buttonHistorical,
      p9buttonInterface,
      //4. P10
      p10status,
      p10tautan,
      p10keterangan,
      p10edit,
      p10delete,
      p10document,
      p10verifikasi,
      p10buttonHistorical,
      p10buttonInterface,
      //5. P11
      p11status,
      p11tautan,
      p11keterangan,
      p11edit,
      p11delete,
      p11document,
      p11verifikasi,
      p11buttonHistorical,
      p11buttonInterface,
      //6. P12
      p12status,
      p12tautan,
      p12keterangan,
      p12edit,
      p12delete,
      p12document,
      p12verifikasi,
      p12buttonHistorical,
      p12buttonInterface,
      //7. P13
      p13status,
      p13tautan,
      p13keterangan,
      p13edit,
      p13delete,
      p13document,
      p13verifikasi,
      p13buttonHistorical,
      p13buttonInterface,
      //8. P14
      p14status,
      p14tautan,
      p14keterangan,
      p14edit,
      p14delete,
      p14document,
      p14verifikasi,
      p14buttonHistorical,
      p14buttonInterface,
      //9. P15
      p15status,
      p15tautan,
      p15keterangan,
      p15edit,
      p15delete,
      p15document,
      p15verifikasi,
      p15buttonHistorical,
      p15buttonInterface,
      //10. P16
      p16status,
      p16tautan,
      p16keterangan,
      p16edit,
      p16delete,
      p16document,
      p16verifikasi,
      p16buttonHistorical,
      p16buttonInterface,
    } = "";
    // -----KATEGORI PENGATURAN P7
    p7buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("7")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
        p7buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t7){
      if(this.state.get_pengaturan_institusi.t7.statusajuan === 3){
        p7buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t7) {
      p7tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t7.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t7.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t7.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t7.dokumen_valid === "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p7edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t7.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t7.statusajuan === 1 || (this.state.get_pengaturan_institusi.t7.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t7.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP7}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p7delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t7.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p7verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t7.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p7buttonHistorical = (
        <>
          <td>
            <Button
              onClick={() => this.handleShowHistorical(7)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p7keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t7.keterangan
              ? this.state.get_pengaturan_institusi.t7.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t7.status === 1) {
        p7status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek1pendidikan"
                        value="ada"
                        onChange={this.handleShowPendidikan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek1pendidikan === 0}
                        type="radio"
                        name="aspek1pendidikan"
                        value="tidakada"
                        onChange={this.handleShowPendidikan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p7tautan}
            {sessiondata.i_idrole === 3
              ? p7edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p7verifikasi
                : ""}
            {p7buttonHistorical}
            {p7buttonInterface}
            {sessiondata.i_idrole === 3 ? p7delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t7.status === 0) {
        p7status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek1pendidikan === 1}
                        name="aspek1pendidikan"
                        value="ada"
                        onChange={this.handleShowPendidikan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek1pendidikan"
                        value="tidakada"
                        onChange={this.handleShowPendidikan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p7keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P7
    // -----KATEGORI PENGATURAN P8

    p8buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("8")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p8buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t8){
      if(this.state.get_pengaturan_institusi.t8.statusajuan === 3){
        p8buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t8) {
      p8tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t8.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t8.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t8.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t8.dokumen_valid === "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p8edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t8.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t8.statusajuan === 1 || (this.state.get_pengaturan_institusi.t8.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t8.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP8}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p8delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t8.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p8verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t8.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p8buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(8)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p8keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t8.keterangan
              ? this.state.get_pengaturan_institusi.t8.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t8.status === 1) {
        p8status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek2penelitian"
                        value="ada"
                        onChange={this.handleShowPenelitian}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek2penelitian === 0}
                        type="radio"
                        name="aspek2penelitian"
                        value="tidakada"
                        onChange={this.handleShowPenelitian}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p8tautan}
            {sessiondata.i_idrole === 3
              ? p8edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p8verifikasi
                : ""}
            {p8buttonHistorical}
            {p8buttonInterface}
            {sessiondata.i_idrole === 3 ? p8delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t8.status === 0) {
        p8status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek2penelitian === 1}
                        name="aspek2penelitian"
                        value="ada"
                        onChange={this.handleShowPenelitian}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek2penelitian"
                        value="tidakada"
                        onChange={this.handleShowPenelitian}
                      />
                      &nbsp;&nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p8keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P8
    // -----KATEGORI PENGATURAN P9

    p9buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("9")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p9buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t9){
      if(this.state.get_pengaturan_institusi.t9.statusajuan === 3){
        p9buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t9) {
      p9tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t9.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t9.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t9.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t9.dokumen_valid === "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p9edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t9.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t9.statusajuan === 1 || (this.state.get_pengaturan_institusi.t9.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t9.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP9}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p9delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t9.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p9verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t9.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p9buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(9)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p9keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t9.keterangan
              ? this.state.get_pengaturan_institusi.t9.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t9.status === 1) {
        p9status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek3pengabdian"
                        value="ada"
                        onChange={this.handleShowPengabdian}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek3pengabdian === 0}
                        type="radio"
                        name="aspek3pengabdian"
                        value="tidakada"
                        onChange={this.handleShowPengabdian}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p9tautan}
            {sessiondata.i_idrole === 3
              ? p9edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p9verifikasi
                : ""}
            {p9buttonHistorical}
            {p9buttonInterface}
            {sessiondata.i_idrole === 3 ? p9delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t9.status === 0) {
        p9status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek3pengabdian === 1}
                        name="aspek3pengabdian"
                        value="ada"
                        onChange={this.handleShowPengabdian}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek3pengabdian"
                        value="tidakada"
                        onChange={this.handleShowPengabdian}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p9keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P9
    // -----KATEGORI PENGATURAN P10

    p10buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("10")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p10buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t10){
      if(this.state.get_pengaturan_institusi.t10.statusajuan === 3){
        p10buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t10) {
      p10tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t10.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t10.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t10.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t10.dokumen_valid ===
              "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p10edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t10.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t10.statusajuan === 1 || (this.state.get_pengaturan_institusi.t10.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t10.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP10}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p10delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t10.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p10verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t10.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p10buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(10)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p10keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t10.keterangan
              ? this.state.get_pengaturan_institusi.t10.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t10.status === 1) {
        p10status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek4pengelolaan"
                        value="ada"
                        onChange={this.handleShowPengelolaan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek4pengelolaan === 0}
                        type="radio"
                        name="aspek4pengelolaan"
                        value="tidakada"
                        onChange={this.handleShowPengelolaan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p10tautan}
            {sessiondata.i_idrole === 3
              ? p10edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p10verifikasi
                : ""}
            {p10buttonHistorical}
            {p10buttonInterface}
            {sessiondata.i_idrole === 3 ? p10delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t10.status === 0) {
        p10status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek4pengelolaan === 1}
                        name="aspek4pengelolaan"
                        value="ada"
                        onChange={this.handleShowPengelolaan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek4pengelolaan"
                        value="tidakada"
                        onChange={this.handleShowPengelolaan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p10keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P10
    // -----KATEGORI PENGATURAN P11

    p11buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("11")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p11buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t11){
      if(this.state.get_pengaturan_institusi.t11.statusajuan === 3){
        p11buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t11) {
      p11tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t11.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t11.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t11.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t11.dokumen_valid ===
              "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p11edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t11.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t11.statusajuan === 1 || (this.state.get_pengaturan_institusi.t11.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t11.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP11}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p11delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t11.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p11verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t11.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p11buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(11)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p11keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t11.keterangan
              ? this.state.get_pengaturan_institusi.t11.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t11.status === 1) {
        p11status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek5kemahasiswaan"
                        value="ada"
                        onChange={this.handleShowKemahasiswaan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek5kemahasiswaan === 0}
                        type="radio"
                        name="aspek5kemahasiswaan"
                        value="tidakada"
                        onChange={this.handleShowKemahasiswaan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p11tautan}
            {sessiondata.i_idrole === 3
              ? p11edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p11verifikasi
                : ""}
            {p11buttonHistorical}
            {p11buttonInterface}
            {sessiondata.i_idrole === 3 ? p11delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t11.status === 0) {
        p11status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek5kemahasiswaan === 1}
                        name="aspek5kemahasiswaan"
                        value="ada"
                        onChange={this.handleShowKemahasiswaan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek5kemahasiswaan"
                        value="tidakada"
                        onChange={this.handleShowKemahasiswaan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p11keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P11
    // -----KATEGORI PENGATURAN P12

    p12buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("12")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p12buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t12){
      if(this.state.get_pengaturan_institusi.t12.statusajuan === 3){
        p12buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t12) {
      p12tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t12.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t12.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t12.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t12.dokumen_valid ===
              "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p12edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t12.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t12.statusajuan === 1 || (this.state.get_pengaturan_institusi.t12.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t12.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP12}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p12delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t12.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p12verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t12.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p12buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(12)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p12keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t12.keterangan
              ? this.state.get_pengaturan_institusi.t12.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t12.status === 1) {
        p12status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek6sdm"
                        value="ada"
                        onChange={this.handleShowSdm}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek6sdm === 0}
                        type="radio"
                        name="aspek6sdm"
                        value="tidakada"
                        onChange={this.handleShowSdm}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p12tautan}
            {sessiondata.i_idrole === 3
              ? p12edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p12verifikasi
                : ""}
            {p12buttonHistorical}
            {p12buttonInterface}
            {sessiondata.i_idrole === 3 ? p12delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t12.status === 0) {
        p12status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek6sdm === 1}
                        name="aspek6sdm"
                        value="ada"
                        onChange={this.handleShowSdm}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek6sdm"
                        value="tidakada"
                        onChange={this.handleShowSdm}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p12keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P12
    // -----KATEGORI PENGATURAN P13

    p13buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("13")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p13buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t13){
      if(this.state.get_pengaturan_institusi.t13.statusajuan === 3){
        p13buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t13) {
      p13tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t13.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t13.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t13.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t13.dokumen_valid ===
              "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p13edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t13.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t13.statusajuan === 1 || (this.state.get_pengaturan_institusi.t13.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t13.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP13}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p13delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t13.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p13verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t13.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p13buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(13)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p13keterangan = (
        <>
          <td colSpan="2">
            {this.state.get_pengaturan_institusi.t13.keterangan
              ? this.state.get_pengaturan_institusi.t13.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t13.status === 1) {
        p13status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek7sarpras"
                        value="ada"
                        onChange={this.handleShowSarpras}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek7sarpras === 0}
                        type="radio"
                        name="aspek7sarpras"
                        value="tidakada"
                        onChange={this.handleShowSarpras}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p13tautan}
            {sessiondata.i_idrole === 3
              ? p13edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p13verifikasi
                : ""}
            {p13buttonHistorical}
            {p13buttonInterface}
            {sessiondata.i_idrole === 3 ? p13delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t13.status === 0) {
        p13status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek7sarpras === 1}
                        name="aspek7sarpras"
                        value="ada"
                        onChange={this.handleShowSarpras}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek7sarpras"
                        value="tidakada"
                        onChange={this.handleShowSarpras}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p13keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P13
    // -----KATEGORI PENGATURAN P14
    p14buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("14")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p14buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t14){
      if(this.state.get_pengaturan_institusi.t14.statusajuan === 3){
        p14buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t14) {
      p14tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t14.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t14.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t14.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t14.dokumen_valid ===
              "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p14edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t14.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t14.statusajuan === 1 || (this.state.get_pengaturan_institusi.t14.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t14.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP14}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p14delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t14.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p14verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t14.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p14buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(14)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p14keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t14.keterangan
              ? this.state.get_pengaturan_institusi.t14.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t14.status === 1) {
        p14status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek8kerjasama"
                        value="ada"
                        onChange={this.handleShowKerjasama}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek8kerjasama === 0}
                        type="radio"
                        name="aspek8kerjasama"
                        value="tidakada"
                        onChange={this.handleShowKerjasama}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p14tautan}
            {sessiondata.i_idrole === 3
              ? p14edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p14verifikasi
                : ""}
            {p14buttonHistorical}
            {p14buttonInterface}
            {sessiondata.i_idrole === 3 ? p14delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t14.status === 0) {
        p14status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek8kerjasama === 1}
                        name="aspek8kerjasama"
                        value="ada"
                        onChange={this.handleShowKerjasama}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek8kerjasama"
                        value="tidakada"
                        onChange={this.handleShowKerjasama}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p14keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P14
    // -----KATEGORI PENGATURAN P15
    p15buttonInterface = (
        <>
          <Button
            onClick={() => this.handleClickInterface("15")}
            className="btn btn-icon btn-warning btn-sm"
            style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
          >
            <i
              class="flaticon-interface-4"
              style={{ color: "#ffffff", fontSize: "14px" }}
            ></i>
          </Button>
        </>
      );
      if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
        p15buttonInterface = ""
      }
      if(this.state.get_pengaturan_institusi.t15){
        if(this.state.get_pengaturan_institusi.t15.statusajuan === 3){
          p15buttonInterface = ""
        }
      }
    if (this.state.get_pengaturan_institusi.t15) {
      p15tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t15.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t15.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t15.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t15.dokumen_valid ===
              "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p15edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t15.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t15.statusajuan === 1 || (this.state.get_pengaturan_institusi.t15.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t15.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP15}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p15delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t15.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p15verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t15.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p15buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(15)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      
      p15keterangan = (
        <>
          <td colSpan="2">
            {this.state.get_pengaturan_institusi.t15.keterangan
              ? this.state.get_pengaturan_institusi.t15.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t15.status === 1) {
        p15status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek9keuangan"
                        value="ada"
                        onChange={this.handleShowKeuangan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek9keuangan === 0}
                        type="radio"
                        name="aspek9keuangan"
                        value="tidakada"
                        onChange={this.handleShowKeuangan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p15tautan}
            {sessiondata.i_idrole === 3
              ? p15edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p15verifikasi
                : ""}
            {p15buttonHistorical}
            {p15buttonInterface}
            {sessiondata.i_idrole === 3 ? p15delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t15.status === 0) {
        p15status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek9keuangan === 1}
                        name="aspek9keuangan"
                        value="ada"
                        onChange={this.handleShowKeuangan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek9keuangan"
                        value="tidakada"
                        onChange={this.handleShowKeuangan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p15keterangan}
          </>
        );
      }
    }
    // -----END KATEGORI PENGATURAN P15
    // -----KATEGORI PENGATURAN P16
     p16buttonInterface = (
      <>
        <Button
          onClick={() => this.handleClickInterface("16")}
          className="btn btn-icon btn-warning btn-sm"
          style={{ minWidth: "50px", borderRadius: "12px", margin: "8px 2px" }}
        >
          <i
            class="flaticon-interface-4"
            style={{ color: "#ffffff", fontSize: "14px" }}
          ></i>
        </Button>
      </>
    );
    if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
      p16buttonInterface = ""
    }
    if(this.state.get_pengaturan_institusi.t16){
      if(this.state.get_pengaturan_institusi.t16.statusajuan === 3){
        p16buttonInterface = ""
      }
    }
    if (this.state.get_pengaturan_institusi.t16) {
      p16tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={this.state.get_pengaturan_institusi.t16.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t16.statusajuan === 3 ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            )}
          </td>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "middle",
            }}
          >
            {this.state.get_pengaturan_institusi.t16.dokumen_valid === "1" ? (
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Sudah Valid
              </Badge>
            ) : this.state.get_pengaturan_institusi.t16.dokumen_valid ===
              "0" ? (
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            ) : (
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            )}
          </td>
        </>
      );
      p16edit = (
        <>
          <td>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t16.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
          {
            this.state.get_pengaturan_institusi.t16.statusajuan === 1 || (this.state.get_pengaturan_institusi.t16.dokumen_valid === "0" || this.state.get_pengaturan_institusi.t16.dokumen_valid === "null") ? (
              <td style={{ fontSize: "12px" }}>
                <Button
                  onClick={this.handleEditButtonP16}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-edit"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            ) : ("")}
        </>
      );
      p16delete = (
        <>
          <td>
          <Button
            onClick={() =>
              this.showDialogDelete(
                this.state.get_pengaturan_institusi.t16.id_ajuan_pengaturan
              )
            }
            className="btn btn-icon btn-danger btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              marginLeft: "5px",
            }}
          >
            <i
              className="flaticon-delete"
              style={{ color: "#FFFFFF", fontSize: "14px" }}
            ></i>
          </Button>
          </td>
        </>
      )
      p16verifikasi = (
        <>
          <td
            style={{
              textAlign: "right",
            }}
          >
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                this.state.get_pengaturan_institusi.t16.id_ajuan_pengaturan
              }
            >
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p16buttonHistorical = (
        <>
          <td style={{ fontSize: "12px" }}>
            <Button
              onClick={() => this.handleShowHistorical(16)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p16keterangan = (
        <>
          <td colSpan="2" style={{ fontSize: "12px" }}>
            {this.state.get_pengaturan_institusi.t16.keterangan
              ? this.state.get_pengaturan_institusi.t16.keterangan
              : ""}
          </td>
        </>
      );
      if (this.state.get_pengaturan_institusi.t16.status === 1) {
        p16status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked
                        name="aspek10kesejahteraan"
                        value="ada"
                        onChange={this.handleShowKesejahteraan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked={this.state.aspek10kesejahteraan === 0}
                        type="radio"
                        name="aspek10kesejahteraan"
                        value="tidakada"
                        onChange={this.handleShowKesejahteraan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Ada"
              )}
            </td>
            {p16tautan}
            {sessiondata.i_idrole === 3
              ? p16edit
              : sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === 2014 ||
                sessiondata.i_idrole === 10
                ? p16verifikasi
                : ""}
            {p16buttonHistorical}
            {p16buttonInterface}
            {sessiondata.i_idrole === 3 ? p16delete:""}
          </>
        );
      } else if (this.state.get_pengaturan_institusi.t16.status === 0) {
        p16status = (
          <>
            <td style={{ fontSize: "12px" }}>
              {sessiondata.i_idrole === 3 ? (
                <>
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        type="radio"
                        checked={this.state.aspek10kesejahteraan === 1}
                        name="aspek10kesejahteraan"
                        value="ada"
                        onChange={this.handleShowKesejahteraan}
                      />
                      &nbsp; Ada
                    </label>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                      <input
                        checked
                        type="radio"
                        name="aspek10kesejahteraan"
                        value="tidakada"
                        onChange={this.handleShowKesejahteraan}
                      />
                      &nbsp; Tidak Ada
                    </label>
                  </span>
                </>
              ) : (
                "Tidak Ada"
              )}
            </td>
            {p16keterangan}
          </>
        );
      }
    }
    let bodyTable = (
      <tr>
        <td colSpan="8">
          <LinearProgress color="secondary" variant="query" />
        </td>
      </tr>
    );

    if (this.state.loadingBar === false) {
      bodyTable = (
        <>
          <tr>
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>1</td>
            <td
              colSpan="2"
              style={{ verticalAlign: "middle", fontSize: "12px" }}
            >
              Standar di aspek pendidikan
            </td>
            {p7status ? (
              p7status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek1pendidikan === 1}
                            name="aspek1pendidikan"
                            value="ada"
                            onChange={this.handleShowPendidikanbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek1pendidikan === 0}
                            type="radio"
                            name="aspek1pendidikan"
                            value="tidakada"
                            onChange={this.handleShowPendidikanbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada Standar aspek
                  pendidikan
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p7buttonInterface}
                </td>
              </>
            )}
          </tr>
          <tr>
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>2</td>
            <td
              colSpan="2"
              style={{ verticalAlign: "middle", fontSize: "12px" }}
            >
              Standar di aspek penelitian
            </td>
            {p8status ? (
              p8status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek2penelitian === 1}
                            name="aspek2penelitian"
                            value="ada"
                            onChange={this.handleShowPenelitianbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek2penelitian === 0}
                            type="radio"
                            name="aspek2penelitian"
                            value="tidakada"
                            onChange={this.handleShowPenelitianbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada Standar di
                  aspek penelitian
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p8buttonInterface}
                </td>
              </>
            )}
          </tr>
          <tr>
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>3</td>
            <td
              colSpan="2"
              style={{ verticalAlign: "middle", fontSize: "12px" }}
            >
              Standar di aspek pengabdian pada masyarakat
            </td>
            {p9status ? (
              p9status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek3pengabdian === 1}
                            name="aspek3pengabdian"
                            value="ada"
                            onChange={this.handleShowPengabdianbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek3pengabdian === 0}
                            type="radio"
                            name="aspek3pengabdian"
                            value="tidakada"
                            onChange={this.handleShowPengabdianbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada Standar di
                  aspek pengabdian pada masyarakat
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p9buttonInterface}
                </td>
              </>
            )}
          </tr>
          <tr>
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>4</td>
            <td
              colSpan="2"
              style={{ verticalAlign: "middle", fontSize: "12px" }}
            >
              Standar Bidang Nonakademik
            </td>
            <td></td>
            <td></td>
            <td colSpan="2"></td>
          </tr>
          <tr>
            <td></td>
            <td style={{ textAlign: "center" }}>•</td>
            <td style={{ verticalAlign: "middle", fontSize: "12px" }}>
              Organisasi
            </td>
            {p10status ? (
              p10status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek4pengelolaan === 1}
                            name="aspek4pengelolaan"
                            value="ada"
                            onChange={this.handleShowPengelolaanbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek4pengelolaan === 0}
                            type="radio"
                            name="aspek4pengelolaan"
                            value="tidakada"
                            onChange={this.handleShowPengelolaanbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada aspek
                  pengelolaan organisasi
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p10buttonInterface}
                </td>
              </>
            )}
          </tr>
          <tr>
            <td></td>
            <td style={{ textAlign: "center" }}>•</td>
            <td style={{ verticalAlign: "middle", fontSize: "12px" }}>
              Keuangan
            </td>
            {p15status ? (
              p15status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek9keuangan === 1}
                            name="aspek9keuangan"
                            value="ada"
                            onChange={this.handleShowKeuanganbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek9keuangan === 0}
                            type="radio"
                            name="aspek9keuangan"
                            value="tidakada"
                            onChange={this.handleShowKeuanganbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada aspek
                  keuangan
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p15buttonInterface}
                </td>
              </>
            )}
          </tr>
          <tr>
            <td></td>
            <td style={{ textAlign: "center" }}>•</td>
            <td style={{ verticalAlign: "middle", fontSize: "12px" }}>
              Kemahasiswaan
            </td>
            {p11status ? (
              p11status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek5kemahasiswaan === 1}
                            name="aspek5kemahasiswaan"
                            value="ada"
                            onChange={this.handleShowKemahasiswaanbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek5kemahasiswaan === 0}
                            type="radio"
                            name="aspek5kemahasiswaan"
                            value="tidakada"
                            onChange={this.handleShowKemahasiswaanbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada aspek
                  kemahasiswaan
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p11buttonInterface}
                </td>
              </>
            )}
          </tr>
          <tr>
            <td></td>
            <td style={{ textAlign: "center" }}>•</td>
            <td style={{ verticalAlign: "middle", fontSize: "12px" }}>
              Ketenagaan
            </td>
            {p12status ? (
              p12status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek6sdm === 1}
                            name="aspek6sdm"
                            value="ada"
                            onChange={this.handleShowSdmbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek6sdm === 0}
                            type="radio"
                            name="aspek6sdm"
                            value="tidakada"
                            onChange={this.handleShowSdmbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada aspek ketenagaan
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p12buttonInterface}
                </td>
              </>
            )}
          </tr>
          <tr>
            <td></td>
            <td style={{ textAlign: "center" }}>•</td>
            <td style={{ verticalAlign: "middle", fontSize: "12px" }}>
              Sarana Prasarana
            </td>
            {p13status ? (
              p13status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek7sarpras === 1}
                            name="aspek7sarpras"
                            value="ada"
                            onChange={this.handleShowSarprasbase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      &nbsp;&nbsp;
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek7sarpras === 0}
                            type="radio"
                            name="aspek7sarpras"
                            value="tidakada"
                            onChange={this.handleShowSarprasbase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada aspek sarana
                  prasarana
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p13buttonInterface}
                </td>
              </>
            )}
          </tr>
          {/* <tr>
            <td></td>
            <td style={{ textAlign: "center" }}>•</td>
            <td style={{ verticalAlign: "middle", fontSize: "12px" }}>
              Sarana Prasarana
            </td>
            {p14status ? (
              p14status
            ) : (
              <>
                <td>
                  {sessiondata.i_idrole === 3 ||
                    sessiondata.i_idrole === "3" ? (
                    <>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            type="radio"
                            checked={this.state.aspek8kerjasama === 1}
                            name="aspek8kerjasama"
                            value="ada"
                            onChange={this.handleShowKerjasamabase}
                          />
                          &nbsp; Ada
                        </label>
                      </span>
                      <span>
                        <label
                          style={{ paddingTop: "8px", marginBottom: "0px" }}
                        >
                          <input
                            checked={this.state.aspek8kerjasama === 0}
                            type="radio"
                            name="aspek8kerjasama"
                            value="tidakada"
                            onChange={this.handleShowKerjasamabase}
                          />
                          &nbsp; Tidak ada
                        </label>
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td
                  colspan="3"
                  style={{ verticalAlign: "middle", fontSize: "12px" }}
                >
                  Institusi Wajib Mengisi Terkait Ada / Tidak ada aspek sarana
                  prasarana
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  {p14buttonInterface}
                </td>
              </>
            )}
          </tr> */}
        </>
      );
    }

    // -----END KATEGORI PENGATURAN P16
    return (
      <>
        <Table responsive>
          <thead className="text-white" style={{ backgroundColor: "#3047ad" }}>
            <tr style={{ textAlign: "left" }}>
              <th
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  textAlign: "center",
                }}
              >
                No
              </th>
              <th
                colSpan="2"
                style={{ fontSize: "12px", textTransform: "uppercase" }}
              >
                Bidang Pengaturan Standar
              </th>
              <th
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  width: "20%",
                }}
              >
                Ada / Tidak Ada
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                }}
              >
                Tautan
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                }}
              >
                Status Verifikasi
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Status Dokumen
              </th>
              <th
                colSpan="5"
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  width: "15%",
                }}
              >
                Aksi
              </th>
            </tr>
          </thead>
          <tbody style={{ textAlign: "left" }}>{bodyTable}</tbody>
        </Table>
        {/* <Modal size="lg" show={this.state.showDelete} onHide={this.handleCloseDelete} >
            <Modal.Header closeButton>
              <Modal.Title>Apakah anda yakin ingin menghapus pengaturan ?</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <div style={{textAlign:'right'}}>
                  <Button style={{marginRight:"1vw", backgroundColor:'#d63933', color:'white'}} 
                    variant="danger"  onClick={this.handleSavePengaturanInstitusi}>
                    Hapus
                  </Button>
                </div>
                <Button style={{marginRight:"1vw", backgroundColor:'#5e5e5e', color:'white'}} variant="secondary" onClick={this.handleCloseDelete}>Batal</Button>
              </Modal.Footer>
          </Modal> */}
        <Modal size="lg" show={this.state.showAda} onHide={this.handleCloseAda}>
          <Modal.Header closeButton>
            <Modal.Title>
              Pengaturan Terkait Standar Yang Ditetapkan Institusi
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi}
                onChange={(e) => this.onInputChange(e, "deskripsi")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan terkait{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={tautan}
                onChange={(e) => this.onInputChange(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
              <br />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
                onClick={this.handleSavePengaturanInstitusi}
              >
                Simpan tautan
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleCloseAda}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals Alasan terkait tidak ada pengaturan*/}
        <Modal
          size="lg"
          show={this.state.showTidakAda}
          onHide={this.handleCloseTidakAda}
        >
          <Modal.Header closeButton>
            <Modal.Title>Berikan Alasan Tidak Ada</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Label>
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="Belum ada pengaturan"
                  onChange={(e) => this.onInputChange(e, "keterangan")}
                />{" "}
                Belum ada pengaturan
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="Masih dalam proses"
                  onChange={(e) => this.onInputChange(e, "keterangan")}
                />{" "}
                Masih dalam proses
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="lainnya"
                  onChange={this.handleChangeAlasan}
                />{" "}
                Lainnya ...
              </label>
            </Form.Label>
            <hr />
            <Form.Group as={Row}>
              <br />
              <br />
              {this.state.isRadioSelected ? (
                <Form.Control
                  size="lg"
                  type="hidden"
                  name="keterangan"
                  placeholder="Disabled"
                  value={keterangan}
                  disabled={this.state.isRadioSelected}
                  onChange={(e) => this.onInputChange(e, "keterangan")}
                />
              ) : (
                <Form.Control
                  size="lg"
                  type="text"
                  name="keterangan"
                  placeholder="Isikan alasan tidak ada"
                  enabled={this.state.isRadioSelected}
                  value={keterangan}
                  onChange={(e) => this.onInputChange(e, "keterangan")}
                />
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSavePengaturanInstitusi}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleCloseTidakAda}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals tambahkan data penetapan PT */}
        <Modal size="lg" show={this.state.showAdd} onHide={this.handleCloseAdd}>
          <Modal.Header closeButton>
            <Modal.Title>Standar Lain Yang Ditetapkan Institusi </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label>Bidang Pengaturan Standar</Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Nama Standar"
                value={keterangan}
                onChange={(e) => this.onInputChange(e, "keterangan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi}
                onChange={(e) => this.onInputChange(e, "deskripsi")}
              />
              <br />
              <Form.Label>Tautan terkait</Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="https://..."
                value={tautan}
                onChange={(e) => this.onInputChange(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
              <br />
              <div style={{ textAlign: "right" }}>
                <Button
                  disabled={loading}
                  style={{
                    marginRight: "1vw",
                    backgroundColor: "#2061e3",
                    color: "white",
                  }}
                  variant="primary"
                  onClick={this.handleAddPengaturan}
                >
                  Simpan
                  {loading && <i className="ml-3 spinner spinner-white"></i>}
                  &nbsp;&nbsp;
                </Button>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAdd}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* DELETE DATA */}
        <Modal
          size="lg"
          show={this.state.showDeleteDialog}
          onHide={this.handleCloseAda}
        >
          <Modal.Header closeButton>
            <Grid container spacing={3}>
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Modal.Title>Apakah anda yakin ?</Modal.Title>
              </Grid>
              <Grid item xs={6} style={{ textAlign: "right" }}>
                <Button
                  style={{ float: "right" }}
                  variant="default"
                  onClick={this.handleCloseAda}
                >
                  <span className="fa fa-window-close"></span>
                </Button>
              </Grid>
            </Grid>
          </Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleCloseAda}
                style={{ marginRight: "1vw" }}
                variant="primary"
              >
                <span className="fa fa-close"></span>Batalkan &nbsp;
              </Button>
              <Button
                onClick={this.deletePengaturanLain}
                disabled={loading}
                className="btn btn-danger"
              >
                <span className="fa fa-trash"></span>&nbsp; Hapus
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {/* Modals Dokumen EDIT Terkait ada pengaturan*/}
        <Modal
          size="lg"
          show={this.state.showEdit}
          onHide={this.handleCloseEdit}
        >
          <Modal.Header closeButton>
            <Modal.Title>Pengaturan Kebijakan SPMI Institusi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsiEdit !== "null" ? deskripsiEdit : "-"}
                onChange={(e) => this.onInputChange(e, "deskripsiEdit")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan terkait{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={this.state.tautanEdit}
                onChange={(e) => this.onInputChangePengaturan(e, "tautanEdit")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
              <br />

              <span style={{ color: "red" }}>{this.state.errorMessage}</span>
              <br />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSavePengaturanEdit}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleCloseEdit}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals Alasan EDIT terkait tidak ada pengaturan*/}
        <Modal
          size="lg"
          show={showHistorical}
          onHide={this.handleCloseHistorical}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {/* {
                  this.state.get_jenis === 1 ? "Pengaturan pengelolaan SPMI Institusi"
                  : this.state.get_jenis === 2 ? "Pengaturan organisasi pengelola SPMI Institusi"
                  : this.state.get_jenis === 3 ? "Pengaturan terkait pelaksanaan standar dalam SPMI Institusi"
                  : this.state.get_jenis === 4 ? "Pengaturan terkait evaluasi pelaksanaan standar"
                  : this.state.get_jenis === 5 ? "Pengaturan terkait pengendalian pelaksanaan standar"
                  : this.state.get_jenis === 6 ? "Pengaturan terkait peningkatan standar dalam SPMI Institusi"
                  : ""
                } */}
              Riwayat Pengaturan Penetapan Standar Yang Ditetapkan Institusi
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <th style={{ textAlign: "center" }}>Status</th>
                <th style={{ textAlign: "center" }}>Tautan/keterangan</th>
                <th style={{ textAlign: "center" }}>Tanggal dibuat</th>
              </thead>
              <tbody>{display_historical}</tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              {/* <Button disabled={loading} onClick={this.handleSavePengaturanEdit} style={{marginRight:"1vw", backgroundColor:'#2061e3', color:'white'}} 
                    variant="primary">
                    SIMPAN
                    {loading && <i className="ml-3 spinner spinner-white"></i>}&nbsp;&nbsp;
                  </Button> */}
            </div>
            <Button variant="secondary" onClick={this.handleCloseHistorical}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default KebijakanPerguruanTinggi;
